import React from "react";
import { enToSw } from "../i18n/translations";

// Tanzanian mobile numbers, matching the server's tz_phone rule (app/Validation/PhoneRules.php):
// 0712345678 (10 digits), 255712345678 or +255712345678.
export const PHONE_MESSAGES = {
  chars: "Use digits only (you may start with +).",
  country: "Only Tanzanian numbers are accepted. Start with 0, 255 or +255.",
  tooMany0: "Too many digits. A number starting with 0 must have exactly 10 digits, e.g. 0712345678.",
  tooFew0: "Too few digits. A number starting with 0 must have exactly 10 digits, e.g. 0712345678.",
  tooMany255: "Too many digits. A number starting with 255 must have exactly 12 digits, e.g. 255712345678.",
  tooFew255: "Too few digits. A number starting with 255 must have exactly 12 digits, e.g. 255712345678.",
  prefix: "Mobile numbers start with 06 or 07 after the code, e.g. 0712345678 or 255712345678.",
};
export const PHONE_MESSAGE = PHONE_MESSAGES.tooMany0;

/** Returns the specific problem with a phone number, or "" when it is valid (or empty). */
export const phoneProblem = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (!/^\+?[\d\s-]+$/.test(raw)) return PHONE_MESSAGES.chars;
  const digits = raw.replace(/\D/g, "");
  if (digits.startsWith("255")) {
    if (digits.length > 12) return PHONE_MESSAGES.tooMany255;
    if (digits.length < 12) return PHONE_MESSAGES.tooFew255;
    return /^255[67]/.test(digits) ? "" : PHONE_MESSAGES.prefix;
  }
  if (digits.startsWith("0")) {
    if (digits.length > 10) return PHONE_MESSAGES.tooMany0;
    if (digits.length < 10) return PHONE_MESSAGES.tooFew0;
    return /^0[67]/.test(digits) ? "" : PHONE_MESSAGES.prefix;
  }
  return PHONE_MESSAGES.country;
};

export const isValidTzPhone = (value) => Boolean(String(value || "").trim()) && !phoneProblem(value);

// Spread onto a phone <input>: the browser blocks submission while the number is wrong.
export const phoneInputProps = {
  type: "tel",
  inputMode: "tel",
  autoComplete: "tel",
  maxLength: 16,
  pattern: "\\+?(255|0)[67][0-9]{8}|\\+?255 ?[67][0-9]{2} ?[0-9]{3} ?[0-9]{3}|0[67][0-9]{2}[ \\-]?[0-9]{3}[ \\-]?[0-9]{3}",
  title: "0712345678 / +255712345678",
  placeholder: "0712345678",
};

// Inline hint shown under a phone field as soon as the typed number is wrong.
// Pass `t` on translated pages; `bilingual` shows English and Swahili together (careers page).
export const PhoneHint = ({ value, t, bilingual = false }) => {
  const problem = phoneProblem(value);
  if (!problem) return null;
  if (bilingual) {
    return (
      <small className="phone-hint" role="alert">
        {problem}
        {enToSw[problem] && <span className="phone-hint-sw">{enToSw[problem]}</span>}
      </small>
    );
  }
  return <small className="phone-hint" role="alert">{t ? t(problem) : problem}</small>;
};
